import { Injectable } from '@angular/core';
import { QuantiteDossierByPeriodeDTO } from '../model/quantite-dossier-by-periode-dto';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { QuantiteDossierByEmployeeDTO } from '../model/quantite-dossier-by-employee-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageDashboardDossierCredit } from '../model/PageDashboardDossierCredit';

@Injectable({
    providedIn: 'root'
  })
  export class NewDashboardProfessionnelService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    


    getDossiersProfessionnelStatus(filter: string, pageIndex: number, pageSize: number): any {
        return this._restClientService.load<PageDashboardDossierCredit>(
            `dashboard-professionnel/dossiers-professionnel-status?filter=${filter}&page=${pageIndex}&size=${pageSize}`
        );
    }

    quantiteDossierByPeriodeAndAgence(codeAgence) 
    {
        return this._restClientService.load<QuantiteDossierByPeriodeDTO>('dashboard-professionnel/quantite-dossier-by-periode-and-agence?codeagence='+codeAgence);
    }
    
    //
    quantiteDossierStatutSurLes6DerniersMois(codeAgence) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-professionnel/quantite-dossier-statut-sur-les-6-derniers-mois?codeagence='+codeAgence);
    }
    
    montantDossierStatutSurLes6DerniersMois(codeAgence) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-professionnel/montant-dossier-statut-sur-les-6-derniers-mois?codeagence='+codeAgence);
    }
    
    slaProduitParPeriode(codeAgence)
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-professionnel/sla-produit-par-periode?codeagence='+codeAgence);
    }
    
    quantiteDossierByEmployee(codeAgence) 
    {
        return this._restClientService.load<QuantiteDossierByEmployeeDTO[]>('dashboard-professionnel/quantite-dossier-by-employee?codeagence='+codeAgence);
    }


}